export class NoteCreationDto {
  constructor(data) {
    this.note = data.note;
  }
}
